import { render, staticRenderFns } from "./password.vue?vue&type=template&id=68d0a634&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=68d0a634&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0a634",
  null
  
)

export default component.exports